var map = {
	"./001-el-2.png": 24893,
	"./002-el-2.png": 52012,
	"./004hero.png": 30751,
	"./004hero.svg": 48741,
	"./004hero_big.png": 82326,
	"./Maxim-test.png": 76094,
	"./Maxim-test.webp": 36500,
	"./achiev_concert.png": 88859,
	"./achiev_concert.webp": 12943,
	"./achiev_picnic.png": 71403,
	"./achiev_picnic.webp": 78510,
	"./achiev_surf.png": 26087,
	"./achiev_surf.webp": 75187,
	"./achiev_yoga.png": 68011,
	"./achiev_yoga.webp": 91188,
	"./b-man.png": 12847,
	"./b-man.svg": 75647,
	"./b-man.webp": 19551,
	"./ball_01.png": 80409,
	"./ball_01.webp": 80458,
	"./bot.png": 28493,
	"./button_sound.png": 6351,
	"./button_sound.svg": 47522,
	"./button_sound.webp": 61199,
	"./button_sound_mute.png": 79215,
	"./button_sound_mute.webp": 47438,
	"./celsium.png": 96025,
	"./celsium.svg": 95005,
	"./charm-sound.png": 73634,
	"./charm-sound.webp": 76742,
	"./city-001-pre.png": 53975,
	"./city-001-pre.webp": 63065,
	"./city-001.png": 56164,
	"./city-001.webp": 35533,
	"./city-002-1.webp": 73239,
	"./city-002.png": 98472,
	"./city-002.webp": 92343,
	"./city-004.png": 8155,
	"./city-005.png": 16675,
	"./close-popup.png": 88768,
	"./close-popup.webp": 44678,
	"./comment-bag.png": 35438,
	"./comment-bag.webp": 48335,
	"./comment-concert-1.png": 23044,
	"./comment-concert-guy.png": 93971,
	"./comment-concert-guy.webp": 10305,
	"./comment-dog.png": 99293,
	"./comment-dog.webp": 1539,
	"./comment-glass-guy.png": 94823,
	"./comment-glass-guy.webp": 46964,
	"./comment-kote.png": 67123,
	"./comment-kote.webp": 98005,
	"./comment-maxim.png": 74857,
	"./comment-maxim.webp": 80951,
	"./comment-picnic-girl.png": 5629,
	"./comment-picnic-girl.webp": 67462,
	"./comment-picninc-girl.png": 25074,
	"./comment-picninc-girl.webp": 21673,
	"./comment-stas.png": 11333,
	"./comment-stas.webp": 97244,
	"./comment-surf-guy-1.png": 99767,
	"./comment-surf-guy.png": 92116,
	"./comment-surf-guy.webp": 53716,
	"./comment-yoga.png": 53146,
	"./comment-yoga.webp": 88893,
	"./concert-001.png": 49113,
	"./concert-001.webp": 92587,
	"./concert-002.png": 73073,
	"./concert-002.webp": 70729,
	"./concert-003.png": 38009,
	"./concert-003.webp": 29342,
	"./concert-004.png": 97087,
	"./concert-004.webp": 61578,
	"./concert-005.png": 26254,
	"./concert-005.webp": 603,
	"./concert-006.png": 97847,
	"./concert-006.webp": 85438,
	"./concert-007.png": 19091,
	"./concert-007.webp": 54908,
	"./concert-008.png": 73694,
	"./concert-008.webp": 34991,
	"./concert-009.png": 14765,
	"./concert-009.webp": 41119,
	"./concert-010.png": 9907,
	"./concert-010.webp": 48767,
	"./concert-011.png": 20111,
	"./concert-011.webp": 75528,
	"./concert-012.png": 65444,
	"./concert-012.webp": 23192,
	"./concert-013.png": 1471,
	"./concert-013.webp": 80429,
	"./concert-outro-001.png": 68450,
	"./concert-outro-001.webp": 12089,
	"./concert-outro-002.png": 4682,
	"./concert-outro-002.webp": 50964,
	"./concert-outro-003.png": 90919,
	"./concert-outro-003.webp": 93385,
	"./concert-outro-004.png": 8752,
	"./concert-outro-004.webp": 24010,
	"./concert-outro-005.png": 82668,
	"./concert-outro-005.webp": 96365,
	"./concert-outro-006.png": 98269,
	"./concert-outro-006.webp": 20352,
	"./concert-outro-007.png": 18543,
	"./concert-outro-007.webp": 35450,
	"./cover-image.png": 12110,
	"./cover-image.webp": 22286,
	"./cover-spirals.png": 5661,
	"./cover-spirals.webp": 37986,
	"./degree-down.png": 20182,
	"./degree-down.svg": 55927,
	"./degree-up.png": 90230,
	"./degree-up.svg": 27666,
	"./dj-icon.png": 39317,
	"./dj-icon.svg": 12474,
	"./dj.png": 95452,
	"./dj.webp": 70584,
	"./dog.png": 19699,
	"./dog.webp": 57878,
	"./equalizer.png": 84224,
	"./equalizer.svg": 38096,
	"./favicon_big.png": 43616,
	"./finish-001-1.png": 4883,
	"./finish-001-1.webp": 44490,
	"./finish-001.png": 68476,
	"./finish-001.webp": 66083,
	"./finish-002.png": 16625,
	"./finish-002.webp": 99136,
	"./finish-003.png": 10476,
	"./finish-003.webp": 23982,
	"./finish-004.png": 61669,
	"./finish-004.webp": 33714,
	"./finish-005.png": 29466,
	"./finish-005.webp": 95446,
	"./finish-006.png": 37867,
	"./finish-006.webp": 46215,
	"./finish-007.png": 77258,
	"./finish-007.webp": 71689,
	"./finish-008.png": 57879,
	"./finish-008.webp": 22520,
	"./help-picnin-game-desktop-2.webp": 76529,
	"./help-picnin-game-desktop-3.webp": 96243,
	"./help-picnin-game-desktop.png": 67174,
	"./help-picnin-game-desktop.webp": 24445,
	"./help-picnin-game-mobile.png": 62362,
	"./help-picnin-game-mobile.webp": 36589,
	"./help-rock-game-audio.webp": 75540,
	"./help-rock-game-desktop.png": 8573,
	"./help-rock-game-desktop.webp": 92857,
	"./help-rock-game-mobile.png": 81188,
	"./help-rock-game-mobile.webp": 72056,
	"./help-rock-game.webp": 26242,
	"./help-surf-game-desktop.png": 97012,
	"./help-surf-game-desktop.webp": 88114,
	"./help-surf-game-mobile.png": 54746,
	"./help-surf-game-mobile.webp": 50135,
	"./help-surf-game-range.webp": 67375,
	"./help-yoga-game-desktop.png": 97252,
	"./help-yoga-game-desktop.webp": 14861,
	"./help-yoga-game-mobile.png": 46340,
	"./help-yoga-game-mobile.webp": 98700,
	"./human.svg": 93486,
	"./image-01-01-pre-retina.png": 50138,
	"./image-01-01-pre-retina.webp": 6309,
	"./image-01-01-pre.png": 97187,
	"./image-01-01-pre.webp": 42805,
	"./image-01-01-retina.png": 55762,
	"./image-01-01-retina.webp": 98027,
	"./image-01-01.svg": 16682,
	"./image-01-02-retina.png": 13545,
	"./image-01-02-retina.webp": 4516,
	"./image-01-02.svg": 32981,
	"./image-01-03-bg.svg": 80216,
	"./image-01-03.svg": 66942,
	"./image-01-03.webp": 67787,
	"./image-02-01.png": 21459,
	"./image-02-01.webp": 1309,
	"./image-02-02-1.png": 28424,
	"./image-02-02-1.webp": 47833,
	"./image-02-02-2.png": 11419,
	"./image-02-02-2.webp": 25981,
	"./image-02-02.png": 74453,
	"./image-02-02.webp": 60961,
	"./image-02-03.png": 34352,
	"./image-02-03.webp": 91939,
	"./image-02-04.png": 8271,
	"./image-02-04.webp": 36617,
	"./image-02-05.png": 95642,
	"./image-02-05.webp": 20662,
	"./image-02-index-2.png": 59312,
	"./image-02-index-2.webp": 66454,
	"./image-02-index-3.webp": 69962,
	"./image-02-index-4.webp": 34137,
	"./image-02-index.png": 21716,
	"./image-02-index.webp": 95568,
	"./image-03-bottom-1.png": 64024,
	"./image-03-bottom-2.png": 1114,
	"./image-03-bottom-3.png": 72672,
	"./image-03-bottom.png": 50449,
	"./image-03-bottom.webp": 2574,
	"./image-04-01.png": 38024,
	"./image-04-01.webp": 34460,
	"./image-1-10.webp": 65625,
	"./image-1-11.webp": 10447,
	"./index-section-two-top-bg.png": 43115,
	"./index-slider/001-el-2.webp": 51791,
	"./index-slider/001-el.png": 6191,
	"./index-slider/001-el.webp": 84864,
	"./index-slider/001-equal.webp": 36649,
	"./index-slider/001city.png": 15506,
	"./index-slider/001city.webp": 43801,
	"./index-slider/002-el-2.png": 89805,
	"./index-slider/002-el-2.webp": 63719,
	"./index-slider/002-el-600.jpg": 45961,
	"./index-slider/002-el-600.png": 83771,
	"./index-slider/002-el-600.webp": 27725,
	"./index-slider/002-el.jpg": 9015,
	"./index-slider/002-el.png": 92581,
	"./index-slider/002-el.webp": 98751,
	"./index-slider/002-equal.webp": 49212,
	"./index-slider/002yoga-sap.png": 72076,
	"./index-slider/002yoga-sap.webp": 75899,
	"./index-slider/003-el-2.png": 19716,
	"./index-slider/003-el-2.webp": 80503,
	"./index-slider/003-el.png": 39639,
	"./index-slider/003-el.webp": 55198,
	"./index-slider/003-equal.webp": 17408,
	"./index-slider/003piknick-layer.png": 35245,
	"./index-slider/003piknick-layer.webp": 6362,
	"./index-slider/004-el-2.png": 88452,
	"./index-slider/004-el-2.webp": 46279,
	"./index-slider/004-el.png": 27688,
	"./index-slider/004-el.webp": 30564,
	"./index-slider/004-equal.webp": 79710,
	"./index-slider/005bird.png": 29695,
	"./index-slider/005bird.webp": 52975,
	"./index-slider/hero004-1.png": 81934,
	"./index-slider/hero004-1.webp": 22416,
	"./index-slider/hero004.png": 75953,
	"./index-slider/hero004.webp": 88150,
	"./kote-popup.png": 40161,
	"./kote-popup.webp": 58590,
	"./mage-02-01.webp": 16241,
	"./mage-04-01.webp": 60941,
	"./maks-drink-kombucha.png": 87710,
	"./maks-drink-kombucha.webp": 25305,
	"./maks-rock.png": 11876,
	"./maks-rock.webp": 83094,
	"./meteor.png": 64184,
	"./meteor.webp": 74020,
	"./mini-sun.png": 96402,
	"./mini-sun.svg": 2521,
	"./mini-sun@2x.png": 59822,
	"./p-man.png": 5838,
	"./p-man.svg": 12869,
	"./p-man.webp": 72133,
	"./page1-bottom-bush.png": 88219,
	"./page1-bottom-bush.svg": 16250,
	"./page1-bottom-bush@2x.png": 38106,
	"./photo-blogger.png": 74949,
	"./photo-blogger.webp": 49976,
	"./photocard.png": 75456,
	"./photocard.webp": 6511,
	"./picnic-001-5.png": 64382,
	"./picnic-001-5.webp": 64858,
	"./picnic-001-6.png": 99895,
	"./picnic-001-6.webp": 74651,
	"./picnic-002.png": 42930,
	"./picnic-002.webp": 3579,
	"./picnic-003.png": 46971,
	"./picnic-003.webp": 86276,
	"./picnic-008.png": 42574,
	"./picnic-012.png": 55123,
	"./pinwheel.png": 80191,
	"./pinwheel.webp": 32344,
	"./polaroid-concert.webp": 62944,
	"./polaroid-picnic.png": 89083,
	"./polaroid-picnic.webp": 45919,
	"./polaroid-surf.png": 16760,
	"./polaroid-surf.webp": 3077,
	"./polaroid-yoga.png": 54256,
	"./polaroid-yoga.webp": 24046,
	"./popup-circles.png": 47865,
	"./popup-circles.webp": 16252,
	"./post-surf-001.png": 95689,
	"./post-surf-001.webp": 79981,
	"./post-surf-002.png": 24969,
	"./post-surf-002.webp": 9082,
	"./post-surf-003.png": 23446,
	"./post-surf-003.webp": 88472,
	"./post-surf-004-1.webp": 40568,
	"./post-surf-004.png": 27404,
	"./post-surf-004.webp": 38445,
	"./post-surf-005.png": 60729,
	"./post-surf-005.webp": 33382,
	"./post-surf-006.png": 89699,
	"./post-surf-006.webp": 97312,
	"./post-surf-007.png": 98368,
	"./post-surf-007.webp": 49250,
	"./post-surf-008.png": 38789,
	"./post-surf-008.webp": 79617,
	"./post-surf-009.png": 17705,
	"./post-surf-009.webp": 21768,
	"./post-surf-finger.png": 98536,
	"./post-surf-finger.webp": 81370,
	"./progress_icon.png": 54448,
	"./progress_icon.svg": 49992,
	"./promocode-copy-2.png": 85938,
	"./promocode-copy-2.webp": 94929,
	"./promocode-copy-done.png": 3509,
	"./promocode-copy-done.webp": 28382,
	"./promocode-copy.png": 54924,
	"./promocode-copy.webp": 24763,
	"./samokat-logo-mini.png": 59721,
	"./samokat-logo-mini.svg": 21757,
	"./samokat-logo-mini.webp": 16637,
	"./samokat_summer_logo_white.png": 70611,
	"./samokat_summer_logo_white.webp": 58927,
	"./schedule.png": 82462,
	"./schedule.svg": 47349,
	"./schedule@2x.png": 23821,
	"./share.png": 82528,
	"./splash-intro-desktop.png": 5828,
	"./splash-intro-desktop.webp": 97731,
	"./splash-intro-desktop_v2.png": 15423,
	"./splash-intro-desktop_v2.webp": 42681,
	"./splash-intro-desktop_v3-mob.png": 77586,
	"./splash-intro-desktop_v3-mob.webp": 12112,
	"./splash-intro-desktop_v3.png": 38036,
	"./splash-intro-desktop_v3.webp": 78386,
	"./splash-intro-desktop_v4-mob.png": 36436,
	"./splash-intro-desktop_v4-mob.webp": 98067,
	"./splash-intro-desktop_v4.webp": 5648,
	"./splash-intro-desktop_v5-mob.png": 41297,
	"./splash-intro-desktop_v5-mob.webp": 13002,
	"./splash-intro.png": 1926,
	"./splash-intro.webp": 56888,
	"./status-card-0.png": 81893,
	"./status-card-0.webp": 73394,
	"./status-card-1.png": 74066,
	"./status-card-1.webp": 82616,
	"./status-card-2.png": 23942,
	"./status-card-2.webp": 39976,
	"./status-card-3.png": 96188,
	"./status-card-3.webp": 11409,
	"./summer-of-emotions.png": 2844,
	"./summer-of-emotions.webp": 59793,
	"./surf-001-2.webp": 31012,
	"./surf-001.png": 92150,
	"./surf-001.webp": 24282,
	"./surf-002.png": 80153,
	"./surf-002.webp": 854,
	"./surf-003.png": 36311,
	"./surf-003.webp": 70887,
	"./surf-004.png": 6123,
	"./surf-004.webp": 3812,
	"./surf-005.png": 51986,
	"./surf-005.webp": 53308,
	"./yoga-001-1.png": 15549,
	"./yoga-001-1.webp": 34217,
	"./yoga-001-2.png": 14671,
	"./yoga-001-2.webp": 53232,
	"./yoga-001-3.webp": 20631,
	"./yoga-001-4.png": 18540,
	"./yoga-001-4.webp": 73113,
	"./yoga-001.png": 16812,
	"./yoga-001.webp": 66070,
	"./yoga-002.png": 8115,
	"./yoga-002.webp": 85048,
	"./yoga-003.png": 9237,
	"./yoga-003.webp": 90975,
	"./yoga-004.png": 12579,
	"./yoga-004.webp": 67688,
	"./yoga-005.png": 86827,
	"./yoga-005.webp": 82995,
	"./yoga-006.png": 56196,
	"./yoga-006.webp": 69764,
	"./yoga-007.png": 36892,
	"./yoga-007.webp": 56708,
	"./yoga-008.png": 74035,
	"./yoga-008.webp": 15589,
	"./yoga-009.png": 72537,
	"./yoga-009.webp": 59830,
	"./yoga-outro-001.png": 91197,
	"./yoga-outro-001.webp": 82121,
	"./yoga-outro-0012.webp": 76,
	"./yoga-outro-002.png": 98967,
	"./yoga-outro-002.webp": 48333,
	"./yoga-outro-003.png": 59694,
	"./yoga-outro-003.webp": 84261,
	"./yoga-outro-004.png": 17045,
	"./yoga-outro-004.webp": 508,
	"./yoga-outro-005.png": 88969,
	"./yoga-outro-005.webp": 72485,
	"./yoga-outro-006.png": 51745,
	"./yoga-outro-006.webp": 70263,
	"./zooms-001.webp": 24092,
	"./zooms-002.webp": 10155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;